import type { ReactNode } from "react";
import clsx from "clsx";
import styles from "./NearbyAirportLabel.module.scss";

interface NearbyAirportLabelProps {
  children: ReactNode;
  className?: string;
}

export const NearbyAirportLabel = ({
  children,
  className,
}: NearbyAirportLabelProps) => {
  return (
    <div className={clsx(styles.nearbyAirportLabel, className)}>{children}</div>
  );
};
